import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import CompanyService from "../services/company.service";
import { useAppState } from "../context/StateContext";

export const useActionCompany = () => {
  const { currentUser } = useAppState();
  const [toggle, setToggle] = useState<boolean>(false);

  useQuery(["company.action"], () => CompanyService.getById(Number(currentUser?.companyId)), {
    enabled: toggle,
    refetchOnWindowFocus: false,
    onSuccess: () => {
      setToggle(false);
    },
  });

  return {
    toggle,
    setToggle,
  };
};
